import '@ant-design/v5-patch-for-react-19';
import 'antd/dist/reset.css';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, Empty } from 'antd';

import MyEmptySVG from './assets/Nodataicon.svg';

import './index.css';
import './styles/styles.css';

import DashboardWrapper from './DashboardWrapper';
import WorkOrderTiffViewer from './containers/WorkOrder/WorkOrderTiffViewer'; // Import your viewer component
import * as serviceWorker from './serviceWorker';
import initSentry from './sentry.config';
import SentryErrorBoundary from './components/SentryErrorBoundary';
import './utils/consoleFilter';
import globalAttachmentService from './services/GlobalAttachmentService';

// Initialize Sentry
initSentry();

const windowUrl = window.location.href;

// Initialize Google Analytics
if (windowUrl.includes('staging') || windowUrl.includes('localhost')) {
  ReactGA.initialize('UA-110662465-3');
} else {
  ReactGA.initialize('UA-110662465-2');
}

// Determine whether to render WorkOrderTiffViewer or DashboardWrapper
const Root = () => {
  const path = window.location.pathname;

  if (path === '/work-order-tiff-viewer') {
    return <WorkOrderTiffViewer />;
  }

  // Render the DashboardWrapper for all other paths
  return (
    <BrowserRouter>
      <SentryErrorBoundary>
        <DashboardWrapper />
      </SentryErrorBoundary>
    </BrowserRouter>
  );
};

//This adds more readable text and visible image to the empty state
const customRenderEmpty = () => (
  <Empty
    image={MyEmptySVG}
    styles={{ image: { height: 55.78125 } }}
    description={
      <span style={{ color: '#123fbf' }}>
        No data
        <br />
        (Remove search or filters if applied)
      </span>
    }
  />
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

//This renders all + the custom render empty as the new empty
root.render(
  <ConfigProvider renderEmpty={customRenderEmpty}>
    <Root />
  </ConfigProvider>
);

// Service worker setup
serviceWorker.unregister();
window.addEventListener('beforeunload', () => {
  globalAttachmentService.cleanup();
});
